/**
 * Step — Blank garment products (BLU-661, client variant). Deep-links to the
 * Products page (NOT an inline embed): blank base garments are created by the
 * product-sync step for each size/colour, so this step verifies they exist and
 * routes the operator to Products to review them. Completion is server-driven —
 * `blankProductCount` (production_type='POD', is_locked=false) > 0. Mirrors the
 * Step3Sync deep-link template.
 *
 * In the client flow this step is hidden by the step model when the client
 * uses the 3PL's garments (no blank garments of its own to set up).
 */
import { useTranslation } from 'react-i18next';
import { StepPane } from '../shell/StepPane';
import { DeepLinkGo, DeepLinkNote, DeepLinkStat } from './DeepLink';

interface StepBlankProductsProps {
  count: number;
}

export function StepBlankProducts({ count }: StepBlankProductsProps) {
  const { t } = useTranslation('onboarding');

  return (
    <StepPane
      title={t('stepBlankProducts.title')}
      description={t('stepBlankProducts.description')}
      primary={<DeepLinkGo page="products" />}
      summary={t('stepBlankProducts.summary', { count })}
    >
      <DeepLinkStat value={count} label={t('stepBlankProducts.count', { count })} />
      {count === 0 && <p className="mt-3 text-xs text-muted-foreground">{t('stepBlankProducts.emptyNote')}</p>}
      <DeepLinkNote page="products" />
    </StepPane>
  );
}
